const config = {
  back_url: process.env.REACT_APP_BACKEND_URL || window.env.back_url,
  // back_url: `https://api.dev.veridart.thesafetraces.com`,
  heatmap_download_scale: 1,
  heatmap_download_scale_multiplier: 0.05,
  google_client_id: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || '',
};

export default config;
